import { placeholderImg } from '../../../utils/links';

const ChildImage = ({ img, thumbnail }) => {
    return <div className={`img ${img?.animation}`}>
        <img className="rounded" src={thumbnail || placeholderImg} />
    </div>
}
export default ChildImage;